<template>
  <div class="page-index"
       @click.stop="menuClose">
    <div :class="{ menu: true, active: menu,'pc-class':true }">
      <div class="menu-btn"
           @click.stop="menuChange"></div>
      <ul>
        <li :class="{ active: pageIndex == 1}"
            @click="goPage(1)">大赛时间</li>
        <li :class="{ active: pageIndex == 2 }"
            @click="goPage(2)">参赛组别</li>
        <li :class="{ active: pageIndex == 3 }"
            @click="goPage(3)">创作主题</li>
        <li :class="{ active: pageIndex == 4 }"
            @click="goPage(4)">奖项设置</li>
        <li :class="{ active: pageIndex == 6 }"
            @click="goPage(6)">专家评委</li>
        <li :class="{ active: pageIndex == 7 }"
            @click="goPage(7)">评奖标准</li>
        <li :class="{ active: pageIndex == 8 }"
            @click="goPage(8)">组织机构</li>
        <li :class="{ active: pageIndex == 10 }"
            @click="goPage(10)">参赛规则</li>
        <li :class="{ active: pageIndex == 11 }"
            @click="goPage(11)">版权声明</li>
      </ul>
    </div>
    <!-- PC -->
    <swiper class="swiper pc-class"
            :options="swiperOption"
            ref="swiper">
      <swiper-slide class="swiper-slide"
                    v-for="(item,index) in pcList"
                    :key="index">
        <div v-if="index == 10"
             class="ruleClass"
             :style="`background-image:url('${item.url}')`">
          <div class="text">
            <p>1.创作完成后，请将同系列的作品打包发送到投稿邮箱contest@ theone.art，注明“唯一艺术·全国少儿数字艺术创作大赛”，并附参赛作品文件（jpg原图及psd源文件）、作品简介（作品名称、画作介绍、创作时间）、作者简介（作者介绍、指导老师、监护人姓名、手机号、微信号、邮箱）以及报名登记表（<a href="https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/%E5%85%A8%E5%9B%BD%E5%B0%91%E5%84%BF%E6%95%B0%E5%AD%97%E8%89%BA%E6%9C%AF%E5%88%9B%E4%BD%9C%E5%A4%A7%E8%B5%9B%E7%99%BB%E8%AE%B0%E8%A1%A8.doc"
                 target="_blank">点击下载</a>），邮件统一命名为“参赛组别+作品名称+作者名+个人/选送机构”。</p>
            <p>2.参赛作品首选数字原生艺术创作，同时也接受实体画作的数码映射，图片格式为静态jpg格式（动态gif格式），画布尺寸：3500px*3500px，图片质量：2MB-10MB。</p>
            <p>3.参赛作品的表现形式、创作风格不限，紧扣大赛创作主题，富有时代精神，鼓励作品在内容和表现手法上创新，但不允许抄袭、拷贝。</p>
            <p>4.参赛作品严禁包合政治、低俗、色情、宗教等内容，不得违反相关法律法规。</p>
            <p>5.请妥善保存作品源文件，所有获奖作品届时必须提交源文件用于展示、影印、出版等。</p>
            <p>6.本次大赛的最终投稿时间截止为2022年9月1日12：00 am UTC+8。</p>
            <p>7.评审结果将在官方平台dac.theone.art及官方微信公众号同步公布。</p>
          </div>
        </div>
        <img v-else
             :src="item.url"
             :class="{'imgEnd':index == 12}" />
      </swiper-slide>
      <div class="swiper-pagination"
           slot="pagination"></div>
    </swiper>
    <!-- phone -->
    <div class="container phone-class">
      <div class="content"
           v-for="(item,index) in phoneList"
           :key="index">
        <div v-if="index == 8"
             class="ruleClass"
             :style="`background-image:url('${item.url}')`">
          <div class="text">
            <p>1.创作完成后，请将同系列的作品打包发送到投稿邮箱contest@ theone.art，注明“唯一艺术·全国少儿数字艺术创作大赛”，并附参赛作品文件（jpg原图及psd源文件）、作品简介（作品名称、画作介绍、创作时间）、作者简介（作者介绍、指导老师、监护人姓名、手机号、微信号、邮箱）以及报名登记表（<a href="https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/%E5%85%A8%E5%9B%BD%E5%B0%91%E5%84%BF%E6%95%B0%E5%AD%97%E8%89%BA%E6%9C%AF%E5%88%9B%E4%BD%9C%E5%A4%A7%E8%B5%9B%E7%99%BB%E8%AE%B0%E8%A1%A8.doc"
                 target="_blank">点击下载</a>），邮件统一命名为“参赛组别+作品名称+作者名+个人/选送机构”。</p>
            <p>2.参赛作品首选数字原生艺术创作，同时也接受实体画作的数码映射，图片格式为静态jpg格式（动态gif格式），画布尺寸：3500px*3500px，图片质量：2MB-10MB。</p>
            <p>3.参赛作品的表现形式、创作风格不限，紧扣大赛创作主题，富有时代精神，鼓励作品在内容和表现手法上创新，但不允许抄袭、拷贝。</p>
            <p>4.参赛作品严禁包合政治、低俗、色情、宗教等内容，不得违反相关法律法规。</p>
            <p>5.请妥善保存作品源文件，所有获奖作品届时必须提交源文件用于展示、影印、出版等。</p>
            <p>6.本次大赛的最终投稿时间截止为2022年9月1日12：00 am UTC+8。</p>
            <p>7.评审结果将在官方平台dac.theone.art及官方微信公众号同步公布。</p>
          </div>
        </div>
        <img v-else
             :src="item.url"
             :class="{'imgEnd':index == 9}" />
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.scss";
import "@/assets/css/base.scss";
import "@/assets/css/rem/index.scss";
import "@/assets/css/rem/indexAdapter.scss";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data () {
    return {
      menu: false,
      pageIndex: 0,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: true,
        direction: "vertical",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      pcList: [
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img1-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img2-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img3-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img4-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img5-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img6-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img7-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img8-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img9-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img10-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/temp-img11-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img12-pc.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img13-pc.png'
        },
      ],
      phoneList: [
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img1-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img2-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img3-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img4-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img5-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img6-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img7-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img8-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/temp-img9-mobile.png'
        },
        {
          url: 'https://theoneart-public.oss-cn-qingdao.aliyuncs.com/pc/children-day/img10-mobile.png'
        },
      ],
    };
  },
  methods: {
    goPage (index) {
      this.pageIndex = index;
      var mySwiper = this.$refs.swiper.$swiper;
      mySwiper.slideTo(this.pageIndex, 500, false);
    },
    menuChange () {
      this.menu = !this.menu;
    },
    menuClose () {
      this.menu = false;
    },
  }
};
</script>